import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Direction } from "radix-ui"
import { Toaster } from "sonner"

import "./index.css"
import App from "./App.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { ConfirmProvider } from "@/components/confirm-dialog.tsx"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* בלי DirectionProvider רכיבי Radix (למשל Tabs) כופים dir="ltr" על התוכן שבתוכם */}
    <Direction.Provider dir="rtl">
      <ThemeProvider>
        <BrowserRouter>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
          <Toaster position="top-center" richColors closeButton dir="rtl" />
        </BrowserRouter>
      </ThemeProvider>
    </Direction.Provider>
  </StrictMode>
)
